exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".component-question-step-two .headings > div {\n  width: 100%; }\n\n.component-question-step-two .checkbox-answer-wrapper {\n  margin-left: 15px; }\n  .component-question-step-two .checkbox-answer-wrapper:nth-child(1) {\n    margin-left: 0; }\n", ""]);

